    import moment from "moment";

    export const columnsInformes = [
        {
			Header: 'Fecha Carga',
			accessor: 'fechaCarga',
			headerClassName: 'justify-content-center',
            Cell: ({ row }) => { return moment(row.original.fechaCarga).format("DD-MM-YY") }
		},
        {
			Header: 'Nombre Documento',
			accessor: 'nombreDocumento',
            headerClassName: 'justify-content-center',
		},
        {
			Header: 'Origen',
			accessor: 'origen',
			headerClassName: 'justify-content-center'
		},
        {
			Header: 'Tipo',
			accessor: 'tipo',
			headerClassName: 'justify-content-center'
		},
        {
			Header: 'Fecha Planificada Carga',
			accessor: 'fechaPlanificada',
			headerClassName: 'justify-content-center',
            Cell: ({ row }) => { return moment(row.original.fechaPlanificada).format("DD-MM-YY") }
		},
        {
            Header: 'Estado Autorización',
            accessor: 'estadoAutorizacion',
            disabledFilters: true
        },
        {
            Header: "Acciones",
            accessor: "acciones",
            className: "text-center"
        },
	];
